/**
 * Las claves de localStorage con este prefijo sobreviven al cierre de sesión.
 * Úsalo solo para preferencias no sensibles (p. ej. la última versión de novedades vista).
 */
export const PERSISTENT_STORAGE_PREFIX = 'aria_persist:';

export function clearLocalStorageKeepingPersistent(): void {
  const persisted = Object.keys(localStorage)
    .filter(key => key.startsWith(PERSISTENT_STORAGE_PREFIX))
    .map(key => [key, localStorage.getItem(key)] as const);

  localStorage.clear();

  persisted.forEach(([key, value]) => {
    if (value !== null) {
      localStorage.setItem(key, value);
    }
  });
}
